import { useEffect } from 'react';
import { useApi, watchSiteChanges } from '../lib/api';

export const useCustomerRequirements = () => {
  const state = useApi('/shop/customer-requirements');
  const { reload } = state;
  useEffect(() => {
    const stop = watchSiteChanges(reload);
    const timer = setInterval(() => { if (!document.hidden) reload(); }, 15000);
    return () => { stop(); clearInterval(timer); };
  }, [reload]);
  return state;
};